import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { RouteEntity } from '@core/router/router.entity';


export const ROUTE_TRANSLATE_KEYS: Record<string, string> = {
    [RouteEntity.Register]: marker('auth.register.page_title'),
    [RouteEntity.Recover]: marker('auth.recover.page_title'),
    [RouteEntity.Basket]: marker('core.main_menu.basket'),
    [RouteEntity.Checkout]: marker('checkout.page_title'),
    [RouteEntity.Topup]: marker('core.main_menu.topup'),
    [RouteEntity.Tickets]: marker('core.main_menu.tickets'),
    [RouteEntity.Services]: marker('core.main_menu.services'),
    [RouteEntity.History]: marker('core.main_menu.history'),
    [RouteEntity.Person]: marker('core.main_menu.person'),
    [RouteEntity.Map]: marker('core.main_menu.map'),
    [RouteEntity.Support]: marker('core.main_menu.support'),
    [RouteEntity.Coupon]: marker('core.main_menu.coupon'),
    [RouteEntity.Medium]: marker('mediums.medium_details.form_title'),
    [RouteEntity.Logout]: marker('core.main_menu.logout'),
    [RouteEntity.PrivacyPolicy]: marker('core.main_menu.privacyPolicy'),
    [RouteEntity.TermsOfUse]: marker('core.main_menu.termsOfUse'),
};
